import { isFunction, voidFn } from '@/src/helpers/utils';

type AdapterConfigProps = {
    adapter?: string;
    baseURL?: string;
    version?: string;
    apiBaseUrlPath?: string;
    contactlistId?: number;
    onStateChange?: (state: unknown, data?: unknown) => void;
    onSubscriptionChange?: (state: unknown) => void;
};

export class AdapterConfig {
    adapter: string;
    baseURL: string;
    version: string;
    apiBaseUrlPath: string;
    contactlistId: number;
    onStateChange: (state: unknown, data?: unknown) => void;
    onSubscriptionChange: (state: unknown) => void;

    constructor(props: AdapterConfigProps = {}) {
        this.adapter = props.adapter ?? '';
        this.baseURL = props.baseURL ?? '';
        this.version = props.version ?? '';
        this.apiBaseUrlPath = '';
        this.contactlistId = 0;

        this.onStateChange = props.onStateChange ?? voidFn;
        this.onSubscriptionChange = props.onSubscriptionChange ?? voidFn;
    }

    validateProp = (prop: string, propValue: unknown): unknown | never => {
        switch (prop) {
            case 'onStateChange':
            case 'onSubscriptionChange':
                return isFunction(propValue) ? propValue : this[prop];
            default:
                break;
        }

        return propValue;
    };

    setProperties = (props: Record<string, unknown> = {}): void => {
        Object.keys(props).forEach((prop) => {
            if (typeof this[prop as keyof AdapterConfig] !== 'undefined') {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (this as any)[prop] = this.validateProp(prop, props[prop]);
            }
        });
    };

    getServiceWorkerName = (): string => `${this.adapter}-sw.js${this.version ? `?v=${this.version}` : ''}`;

    getAPIUrl = (): string => `${this.baseURL.replace(/\/+$/g, '')}/${this.apiBaseUrlPath}`;

    getAPIKeyUrl = (): string => `${this.getAPIUrl()}key`;

    getAPIRegisterURL = (): string => `${this.getAPIUrl()}register`;

    getAPIUnregisterURL = (): string => `${this.getAPIUrl()}unregister`;
}
